import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InspectionService } from 'src/app/shared/services/inspection.service';

@Component({
  selector: 'app-pdf-page',
  templateUrl: './pdf-page.component.html',
  styleUrls: ['./pdf-page.component.scss']
})
export class PdfPageComponent implements OnInit {

  data: any = null;

  constructor(
    private route: ActivatedRoute,
    private service: InspectionService,
  ) { }

  async ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjb21wYW55IjoiYWRkLCB1cGRhdGUsIHJlbW92ZSwgZ2V0LCBwYXRjaCIsInBlcnNvbiI6ImFkZCwgdXBkYXRlLCByZW1vdmUsIGdldCwgcGF0Y2giLCJhY2NlcHRUZXJtcyI6ImFkZCwgdXBkYXRlLCByZW1vdmUsIGdldCwgcGF0Y2giLCJkaXN0cmlidXRpb25SdWxlcyI6ImFkZCwgdXBkYXRlLCByZW1vdmUsIGdldCwgcGF0Y2giLCJnZW9ncmFwaHlSZWdpb24iOiJhZGQsIHVwZGF0ZSwgcmVtb3ZlLCBnZXQsIHBhdGNoIiwiaW5zcGVjdGlvbiI6ImFkZCwgdXBkYXRlLCByZW1vdmUsIGdldCwgcGF0Y2giLCJyZXBvcnQiOiJhZGQsIHVwZGF0ZSwgcmVtb3ZlLCBnZXQsIHBhdGNoIiwic3VydmV5cyI6ImFkZCwgdXBkYXRlLCByZW1vdmUsIGdldCwgcGF0Y2giLCJjb21wYW55UGVyc29uIjoiZ2V0IiwiUHJvZmlsZSI6IjEiLCJDb21wYW55UGVyc29uSWQiOiI2NmQ4YTk4ZS1hMmRkLTRhZWItYjAwNC0wOGQ4ZGMzZDQxNmEiLCJzdWIiOiIxMDExIiwiZW1haWwiOiJlbGlhbmRyb0BwbGFuZXR1bi5jb20uYnIiLCJqdGkiOiI3YjhiYThiZS1jYTNlLTRlYTQtYjlmMy0wMzVjNTFhYjY2ZTUiLCJuYmYiOjE2MTk3MTkzMDQsImlhdCI6MTYxOTcxOTMwNCwiVXNlck5hbWUiOiJFbGlhbmRybyBGYWJyaWNpbyBQdWdnaW5hIiwiT2ZmaWNlIjoiLSIsIkFyZWEiOiItIiwiUGVyc29uIjoiYzdmM2RmYzktZjUwNS00NzRlLWIzZjktMDhkOGRjM2Q0MTY4IiwibG9naW4iOiIyNTM0NzkwMjg1MCIsImV4cCI6MTYxOTcyNjUwNCwiaXNzIjoiTWV1U2lzdGVtYSIsImF1ZCI6Imh0dHBzOi8vbG9jYWxob3N0In0.mgHO8IVVOXMd2Msi_ie80k3lRUFTjRNNytN9XbZ760I"

    this.data = await this.service.getById(id,token);
  }

  getSurveyType(){
    switch (this.data?.surveyType) {
      case 1:
        return 'Mobile'
        break;
      case 2:
        return 'Especial'
        break;
      case 3:
        return 'Tradicional'
        break;
    }
  }

  getSurveyReason(){
    switch (this.data?.motiveSurvey) {
      case 1:
        return 'Seguro Novo'
        break;
      case 2:
        return 'Renovação'
        break;
      case 5:
        return 'Reprogramação de parcela'
        break;
    }
  }
}
